import React from "react";
import { ShopfloMainLogo } from "@shopflo/ui/shopflo-logo";

interface ShopfloBadgeProps {
  className?: string;
  textColor?: string;
}

const ShopfloBadge: React.FC<ShopfloBadgeProps> = ({ className = "", textColor = "#A1A1AA" }) => {
  return (
    <div className={`flex flex-row items-center space-x-1 ${className}`}>
      <span className="text-text-xxs-medium text-zinc-400"
        style={{
          color: textColor,
        }}
      >Powered by</span>
      <ShopfloMainLogo className="h-3 text-zinc-400" color={textColor} />
    </div>
  );
};

export default ShopfloBadge;
